<template>
    <div class="main-panel">
        <top-navbar></top-navbar>
        <div class="content">
            <div class="card">
                <FlashMessage :position="'right top'"></FlashMessage>

                <div class="card-header">
                    <h4 class="title">Edit Generated Order</h4>
                </div>
                <div class="card-body">
                    <form @submit.prevent="submit" ref="offlineorderform">
                        <div class="row">

                            <div class="col-md-4" v-if="customerdata != null">
                                Name: <label>{{ customerdata.name }}</label><br>
                                Number: <label>{{ customerdata.number }}</label><br>
                                Email: <label>{{ customerdata.email }}</label>
                            </div>
                            <div class="col-md-4" v-if="customerdata != null">
                                Address:<label>{{ customerdata.houseappartment }}, {{ customerdata.area }},
                                    {{ customerdata.city }}, {{ customerdata.state }}, {{ customerdata.country }},
                                    {{ customerdata.pincode }}</label><br>
                            </div>
                            <div class="col-md-4">
                                Order Id: <label><b>{{ this.$route.params.id }}</b></label><br>
                            </div>
                        </div><br>
                        <div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label>Category<em style="color:red">*</em></label>
                                    <select class="form-control" v-model.trim="$v.orderdata.categoryid.$model">
                                        <option disabled value>Select category</option>
                                        <option v-for="(list, index) in category" :value="list.categoryid" :key="index">
                                            {{ list.categoryname }}
                                        </option>
                                    </select>
                                    <div class="error" v-if="submitted && !$v.orderdata.categoryid.required">Please
                                        select category</div>
                                </div>

                                <div class="col-md-4">
                                    <label>Delivery Date<em style="color:red">*</em></label>
                                    <datepicker placeholder="Select Date" v-model="vmodeldeliverydate"
                                        @selected="CallDateFunction" class="deliverydate"
                                        :disabledDates="disabledDates"></datepicker>
                                    <div class="error" v-if="submitted && !$v.vmodeldeliverydate.required">Please select
                                        delivery date</div>
                                </div>
                            </div><br>

                            <!-- Sofa Form -->
                            <div v-if="orderdata.categoryid == 3">
                                <div class="row">
                                    <div class="col-md-4">
                                        <label>Design</label>
                                        <select class="form-control" v-model="attributes.sofadesign">
                                            <option disabled value>Select design</option>
                                            <option v-for="(list, index) in sofadesign" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4">
                                        <label>Size of Sofa</label>
                                        <select class="form-control" v-model="attributes.sofasize">
                                            <option disabled value>Select size of sofa</option>
                                            <option v-for="(list, index) in sofasize" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4">
                                        <label>Fabric</label>
                                        <select class="form-control" v-model="attributes.sofafabric">
                                            <option disabled value>Select fabric</option>
                                            <option v-for="(list, index) in sofafabric" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                </div><br>

                                <div class="row">
                                    <div class="col-md-4">
                                        <label>Body</label>
                                        <select class="form-control" v-model="attributes.sofabody">
                                            <option disabled value>Select body</option>
                                            <option v-for="(list, index) in sofabody" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4">
                                        <label>Cushion</label>
                                        <select class="form-control" v-model="attributes.sofacushion">
                                            <option disabled value>Select cushion</option>
                                            <option v-for="(list, index) in sofacushion" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4">
                                        <label>Polish</label>
                                        <select class="form-control" v-model="attributes.sofapolish">
                                            <option disabled value>Select polish</option>
                                            <option v-for="(list, index) in sofapolish" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                </div><br>
                                <div class="row">
                                    <div class="col-md-4">
                                        <label>Remark</label>
                                        <textarea class="form-control" v-model.trim="attributes.remark"
                                            placeholder="Enter remark"></textarea>
                                        <!-- <div class="error" v-if="submitted && !$v.attributes.remark.required">Please
                                            enter remark</div> -->
                                    </div>
                                </div><br>
                            </div>
                            <!-- Sofa Form -->

                            <!-- Dining Table Form -->
                            <div v-if="orderdata.categoryid == 8">
                                <div class="row">
                                    <div class="col-md-4">
                                        <label>Chair Design</label>
                                        <select class="form-control" v-model="attributes.diningchairdesign">
                                            <option disabled value>Select chair design</option>
                                            <option v-for="(list, index) in diningchairdesign"
                                                :value="list.Attribute_id" :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4">
                                        <label>Table Design</label>
                                        <select class="form-control" v-model="attributes.diningtabledesign">
                                            <option disabled value>Select tabel design</option>
                                            <option v-for="(list, index) in diningtabledesign"
                                                :value="list.Attribute_id" :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4">
                                        <label>Nos. of chair</label>
                                        <input class="form-control" type="text" label="Nos of chair"
                                            placeholder="Enter nos. of chair" v-model="attributes.nosofchair" />
                                    </div>

                                </div><br>

                                <div class="row">
                                    <div class="col-md-4">
                                        <label>Size of Table</label>
                                        <select class="form-control" v-model="attributes.diningsizeoftable">
                                            <option disabled value>Select size of table</option>
                                            <option v-for="(list, index) in diningsizeoftable"
                                                :value="list.Attribute_id" :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4">
                                        <label>Size of Marble/Glass</label>
                                        <select class="form-control" v-model="attributes.diningsizeofmarble">
                                            <option disabled value>Select marble/glass</option>
                                            <option v-for="(list, index) in diningsizeofmarble"
                                                :value="list.Attribute_id" :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4">
                                        <label>Polish</label>
                                        <select class="form-control" v-model="attributes.diningpolish">
                                            <option disabled value>Select polish</option>
                                            <option v-for="(list, index) in diningpolish" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                </div><br>

                                <div class="row">
                                    <div class="col-md-4">
                                        <label>Below Glass</label>
                                        <select class="form-control" v-model="attributes.diningbelowglass">
                                            <option disabled value>Select below glass</option>
                                            <option v-for="(list, index) in diningbelowglass" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4">
                                        <label>Fabric</label>
                                        <select class="form-control" v-model="attributes.diningfabric">
                                            <option disabled value>Select fabric</option>
                                            <option v-for="(list, index) in diningfabric" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-4">
                                        <label>Remark</label>
                                        <textarea class="form-control" v-model.trim="attributes.remark"
                                            placeholder="Enter remark"></textarea>
                                        <!-- <div class="error" v-if="submitted && !$v.attributes.remark.required">Please
            enter remark</div> -->
                                    </div>
                                </div><br>
                            </div>
                            <!-- Dining Table Form -->

                            <!-- Center Table Form -->
                            <div v-if="orderdata.categoryid == 6">
                                <div class="row">
                                    <div class="col-md-4">
                                        <label>Center Table Name</label>
                                        <select class="form-control" v-model="attributes.centertablename">
                                            <option disabled value>Select center table name</option>
                                            <option v-for="(list, index) in centertablename" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4">
                                        <label>Size</label>
                                        <select class="form-control" v-model="attributes.tablesize">
                                            <option disabled value>Select size</option>
                                            <option v-for="(list, index) in tablesize" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4">
                                        <label>Polish</label>
                                        <select class="form-control" v-model="attributes.tablepolish">
                                            <option disabled value>Select polish</option>
                                            <option v-for="(list, index) in tablepolish" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                </div><br>

                                <div class="row">

                                    <div class="col-md-4">
                                        <label>Top</label>
                                        <select class="form-control" v-model="attributes.top">
                                            <option value disabled>Selct top</option>
                                            <option value="marble">Marble</option>
                                            <option value="glass">Glass</option>
                                        </select>
                                    </div>

                                    <div class="col-md-4" v-if="attributes.top == 'marble'">
                                        <label>Size of Marble</label>
                                        <select class="form-control" v-model="attributes.sizeofmarble">
                                            <option disabled value>Select size of marble</option>
                                            <option v-for="(list, index) in sizeofmarble" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4" v-if="attributes.top == 'glass'">
                                        <label>Size of Glass</label>
                                        <select class="form-control" v-model="attributes.sizeofglass">
                                            <option disabled value>Select size of glass</option>
                                            <option v-for="(list, index) in sizeofglass" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4" v-if="attributes.top == 'glass'">
                                        <label>Below of Glass</label>
                                        <select class="form-control" v-model="attributes.belowofglass">
                                            <option disabled value>Select below of glass</option>
                                            <option v-for="(list, index) in belowofglass" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-4">
                                        <label>Remark</label>
                                        <textarea class="form-control" v-model.trim="attributes.remark"
                                            placeholder="Enter remark"></textarea>
                                        <!-- <div class="error" v-if="submitted && !$v.attributes.remark.required">Please
            enter remark</div> -->
                                    </div>
                                </div><br>
                            </div>
                            <!-- Center Table Form -->

                            <!-- Bed Room Form -->
                            <div v-if="orderdata.categoryid == 7">
                                <div class="row">
                                    <div class="col-md-4">
                                        <label>Design</label>
                                        <select class="form-control" v-model="attributes.beddesign">
                                            <option disabled value>Select design</option>
                                            <option v-for="(list, index) in beddesign" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                </div><br>

                                <div class="row">
                                    <div class="col-md-3">
                                        <label>Double bed Mattress Size</label>
                                        <select class="form-control" v-model="attributes.doublebedmattresssize">
                                            <option disabled value>Select double bed mattress size </option>
                                            <option v-for="(list, index) in doublebedmattresssize"
                                                :value="list.Attribute_id" :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <label>Types of Material</label>
                                        <select class="form-control" v-model="attributes.doublebedmaterial">
                                            <option disabled value>Select types of material </option>
                                            <option v-for="(list, index) in doublebedmaterial"
                                                :value="list.Attribute_id" :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <label>Colour</label>
                                        <select class="form-control" v-model="attributes.doublebedmattresscolor">
                                            <option disabled value>Select colour</option>
                                            <option value="other">Other</option>
                                            <option v-for="(list, index) in doublebedcolour" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <div v-if="attributes.doublebedmattresscolor == 'other'">
                                            <label>Colour</label>
                                            <input class="form-control" type="text" label="Colour"
                                                placeholder="Enter colour"
                                                v-model="attributes.doublebedmattresscolorcode" />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <label>Remark</label>
                                        <textarea class="form-control" v-model.trim="attributes.doublebedremark"
                                            placeholder="Enter remark"></textarea>
                                        <!-- <div class="error" v-if="submitted && !$v.attributes.remark.required">Please
            enter remark</div> -->
                                    </div>
                                </div><br>

                                <div class="row">
                                    <div class="col-md-3">
                                        <label>Wardrobe Size</label>
                                        <select class="form-control" v-model="attributes.wardrobesize">
                                            <option disabled value>Select wardrobe size</option>
                                            <option v-for="(list, index) in wardrobesize" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <label>Types of Material</label>
                                        <select class="form-control" v-model="attributes.wardrobematerial">
                                            <option disabled value>Select types of material</option>
                                            <option v-for="(list, index) in wardrobematerial" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <label>Colour</label>
                                        <select class="form-control" v-model="attributes.wardrobecolor">
                                            <option disabled value>Select colour</option>
                                            <option value="other">Other</option>
                                            <option v-for="(list, index) in wardrobecolour" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <div v-if="attributes.wardrobecolor == 'other'">
                                            <label>Colour</label>
                                            <input class="form-control" type="text" label="Colour"
                                                placeholder="Enter colour" v-model="attributes.wardrobecolorcode" />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <label>Remark</label>
                                        <textarea class="form-control" v-model.trim="attributes.wardroberemark"
                                            placeholder="Enter remark"></textarea>
                                        <!-- <div class="error" v-if="submitted && !$v.attributes.remark.required">Please
            enter remark</div> -->
                                    </div>
                                </div><br>

                                <div class="row">
                                    <div class="col-md-3">
                                        <label>Dressing Table Size</label>
                                        <select class="form-control" v-model="attributes.dressingtablesize">
                                            <option disabled value>Select dressing table size</option>
                                            <option v-for="(list, index) in dressingtablesize"
                                                :value="list.Attribute_id" :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <label>Types of Material</label>
                                        <select class="form-control" v-model="attributes.dressingmaterial">
                                            <option disabled value>Select types of material</option>
                                            <option v-for="(list, index) in dressingmaterial" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <label>Colour</label>
                                        <select class="form-control" v-model="attributes.dressingtablecolor">
                                            <option disabled value>Select colour</option>
                                            <option value="other">Other</option>
                                            <option v-for="(list, index) in dressingcolour" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <div v-if="attributes.dressingtablecolor == 'other'">
                                            <label>Colour</label>
                                            <input class="form-control" type="text" label="Colour"
                                                placeholder="Enter colour"
                                                v-model="attributes.dressingtablecolorcode" />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <label>Remark</label>
                                        <textarea class="form-control" v-model.trim="attributes.dressingremark"
                                            placeholder="Enter remark"></textarea>
                                        <!-- <div class="error" v-if="submitted && !$v.attributes.remark.required">Please
            enter remark</div> -->
                                    </div>
                                </div><br>

                                <div class="row">
                                    <div class="col-md-3">
                                        <label>Side Table Size</label>
                                        <select class="form-control" v-model="attributes.sidetablesize">
                                            <option disabled value>Select side table size</option>
                                            <option v-for="(list, index) in sidetablesize" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <label>Types of Material</label>
                                        <select class="form-control" v-model="attributes.sidetablematerial">
                                            <option disabled value>Select types of material</option>
                                            <option v-for="(list, index) in sidetablematerial"
                                                :value="list.Attribute_id" :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <label>Colour</label>
                                        <select class="form-control" v-model="attributes.sidetablecolor">
                                            <option disabled value>Select colour</option>
                                            <option value="other">Other</option>
                                            <option v-for="(list, index) in sidetablecolour" :value="list.Attribute_id"
                                                :key="index">
                                                {{ list.value }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <div v-if="attributes.sidetablecolor == 'other'">
                                            <label>Colour</label>
                                            <input class="form-control" type="text" label="Colour"
                                                placeholder="Enter colour" v-model="attributes.sidetablecolorcode" />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <label>Remark</label>
                                        <textarea class="form-control" v-model.trim="attributes.sidetableremark"
                                            placeholder="Enter remark"></textarea>
                                        <!-- <div class="error" v-if="submitted && !$v.attributes.remark.required">Please
            enter remark</div> -->
                                    </div>
                                </div><br>
                            </div>

                            <!-- Bed Room Form -->

                            <div class="text">
                                <button type="submit" class="btn btn-secondary dashboard">Generate Order</button>&nbsp;
                                <router-link to="/admin/dashboard/offlineorders"><button type="button"
                                        class="btn btn-secondary dashboard">Cancel</button></router-link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div v-if="getcustomerorderdata != ''">
                <table class="table table-borderd mt-5">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Category Name</th>
                            <th>Order date</th>
                            <th>Delivery date</th>
                            <th>Form</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="data in getcustomerorderdata" v-bind:key="data.offlineorderid">
                            <td>{{ data.productofflineindex }}</td>
                            <td>{{ data.categoryname }}</td>
                            <td>{{ data.created_at | formatDate }}</td>
                            <td>{{ data.deliverydate }}</td>
                            <td>
                                <a @click="generateReport(data.offlineorderid)">
                                    <b-icon-printer></b-icon-printer>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <content-footer></content-footer>
    </div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import Fuse from 'fuse.js'
import download from 'downloadjs'
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import Datepicker from 'vuejs-datepicker'
import format from 'date-fns/format'
import {
    required,
    minLength,
    maxLength,
    between,
    sameAs,
    email,
    reset
} from "vuelidate/lib/validators";
export default {
    name: 'addOfflineOrder',
    components: {
        TopNavbar,
        ContentFooter,
        ValidationError,
        Datepicker,
    },

    data() {
        return {
            submitted: false,
            getcustomerorderdata: [],
            vmodeldeliverydate: '',
            indexofproduct: '',
            deliverydate: '',
            disabledDates: {
                to: new Date(Date.now() - 8640000)
            },
            options: [],
            category: [],
            top: '',
            doublebedmattresscolor: [],
            wardrobecolor: [],
            dressingtablecolor: [],
            sidetablecolor: [],
            category: [],
            subcategory: [],
            sofadesign: [],
            sofasize: [],
            sofafabric: [],
            sofabody: [],
            sofacushion: [],
            sofapolish: [],
            centertablename: [],
            tablesize: [],
            tablepolish: [],
            tabletop: [],
            sizeofmarble: [],
            sizeofglass: [],
            belowofglass: [],
            beddesign: [],
            doublebedmattresssize: [],
            doublebedmaterial: [],
            doublebedcolour: [],
            wardrobesize: [],
            wardrobematerial: [],
            wardrobecolour: [],
            dressingtablesize: [],
            dressingmaterial: [],
            dressingcolour: [],
            sidetablesize: [],
            sidetablematerial: [],
            sidetablecolour: [],
            diningchairdesign: [],
            diningtabledesign: [],
            diningsizeoftable: [],
            diningsizeofmarble: [],
            diningpolish: [],
            diningbelowglass: [],
            diningfabric: [],
            customerdata: null,
            orderdata: {
                categoryid: '',
            },
            attributes: {
                nosofchair: '',
                doublebedmattresscolor: '',
                wardrobecolor: '',
                dressingtablecolor: '',
                sidetablecolor: '',
                doublebedmattresscolorcode: '',
                wardrobecolorcode: '',
                dressingtablecolorcode: '',
                sidetablecolorcode: '',
                top: '',
                sofadesign: '',
                sofasize: '',
                sofafabric: '',
                sofabody: '',
                sofacushion: '',
                sofapolish: '',
                centertablename: '',
                tablesize: '',
                tablepolish: '',
                tabletop: '',
                sizeofmarble: '',
                sizeofglass: '',
                belowofglass: '',
                beddesign: '',
                doublebedmattresssize: '',
                doublebedmaterial: '',
                doublebedcolour: '',
                wardrobesize: '',
                wardrobematerial: '',
                wardrobecolour: '',
                dressingtablesize: '',
                dressingmaterial: '',
                dressingcolour: '',
                sidetablesize: '',
                sidetablematerial: '',
                sidetablecolour: '',
                diningchairdesign: '',
                diningtabledesign: '',
                diningsizeoftable: '',
                diningsizeofmarble: '',
                diningpolish: '',
                diningbelowglass: '',
                diningfabric: '',
                remark: '',
                sidetableremark: '',
                dressingremark: '',
                wardroberemark: '',
                doublebedremark: '',
            },
        }
    },

    validations: {
        orderdata: {
            categoryid: {
                required
            },
        },

        vmodeldeliverydate: {
            required
        },

        customerdata: {
            required
        }
    },

    methods: {

        onlyNumber($event) {
            //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault();
            }
        },

        CallDateFunction(date) {
            this.deliverydate = format(date, 'dd/MM/yyyy')
        },

        generateReport(id) {
            this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/generateform/` + id, {
                responseType: 'blob'
            }).then((res) => {
                // const content = res.headers['content-type'];
                // showPdf(res.data, 'Form', content)
                var blob = new Blob([res.data], { type: 'application/pdf' });
                var blobURL = URL.createObjectURL(blob);
                window.open(blobURL);
            });
        },

        getcustomerorder() {
            this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/getcustomerorder/` + this.$route.params.id).then((data) => {
                this.getcustomerorderdata = data.data;
                let index = data.data.slice(-1); {
                    data.data.length == 0 ? this.indexofproduct = 0 : this.indexofproduct = index[0].productofflineindex
                }
            });
        },

        submit() {
            this.submitted = true;
            this.$v.$touch()

            if (this.$v.$invalid) {
                return;
            } else {
                this.indexofproduct = this.indexofproduct + 1;
                let formData = new FormData();
                formData.append('customerid', this.customerdata.id);
                formData.append('deliverydate', this.deliverydate);
                formData.append('offline_order_referenceid', this.$route.params.id);
                formData.append('productofflineindex', this.indexofproduct);
                formData.append('categoryid', this.orderdata.categoryid);
                formData.append('nosofchair', this.attributes.nosofchair);
                formData.append('doublebedmattresscolor', this.attributes.doublebedmattresscolor);
                formData.append('wardrobecolor', this.attributes.wardrobecolor);
                formData.append('dressingtablecolor', this.attributes.dressingtablecolor);
                formData.append('sidetablecolor', this.attributes.sidetablecolor);
                formData.append('doublebedmattresscolorcode', this.attributes.doublebedmattresscolorcode);
                formData.append('wardrobecolorcode', this.attributes.wardrobecolorcode);
                formData.append('dressingtablecolorcode', this.attributes.dressingtablecolorcode);
                formData.append('sidetablecolorcode', this.attributes.sidetablecolorcode);
                formData.append('top', this.attributes.top);
                formData.append('sofadesign', this.attributes.sofadesign);
                formData.append('sofasize', this.attributes.sofasize);
                formData.append('sofabody', this.attributes.sofabody);
                formData.append('sofacushion', this.attributes.sofacushion);
                formData.append('sofapolish', this.attributes.sofapolish);
                formData.append('sofafabric', this.attributes.sofafabric);
                formData.append('centertablename', this.attributes.centertablename);
                formData.append('tablesize', this.attributes.tablesize);
                formData.append('tablepolish', this.attributes.tablepolish);
                formData.append('tabletop', this.attributes.tabletop);
                formData.append('sizeofmarble', this.attributes.sizeofmarble);
                formData.append('sizeofglass', this.attributes.sizeofglass);
                formData.append('belowofglass', this.attributes.belowofglass);
                formData.append('beddesign', this.attributes.beddesign);
                formData.append('doublebedmattresssize', this.attributes.doublebedmattresssize);
                formData.append('doublebedmaterial', this.attributes.doublebedmaterial);
                formData.append('doublebedcolour', this.attributes.doublebedcolour);
                formData.append('wardrobesize', this.attributes.wardrobesize);
                formData.append('wardrobematerial', this.attributes.wardrobematerial);
                formData.append('wardrobecolour', this.attributes.wardrobecolour);
                formData.append('dressingtablesize', this.attributes.dressingtablesize);
                formData.append('dressingmaterial', this.attributes.dressingmaterial);
                formData.append('dressingcolour', this.attributes.dressingcolour);
                formData.append('sidetablesize', this.attributes.sidetablesize);
                formData.append('sidetablematerial', this.attributes.sidetablematerial);
                formData.append('sidetablecolour', this.attributes.sidetablecolour);
                formData.append('diningchairdesign', this.attributes.diningchairdesign);
                formData.append('diningtabledesign', this.attributes.diningtabledesign);
                formData.append('diningsizeoftable', this.attributes.diningsizeoftable);
                formData.append('diningsizeofmarble', this.attributes.diningsizeofmarble);
                formData.append('diningbelowglass', this.attributes.diningbelowglass);
                formData.append('diningpolish', this.attributes.diningpolish);
                formData.append('diningfabric', this.attributes.diningfabric);
                formData.append('remark', this.attributes.remark);
                formData.append('sidetableremark', this.attributes.sidetableremark);
                formData.append('dressingremark', this.attributes.dressingremark);
                formData.append('wardroberemark', this.attributes.wardroberemark);
                formData.append('doublebedremark', this.attributes.doublebedremark);

                this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/addofflineorder`, formData)
                    .then(({
                        data
                    }) => {
                        this.orderdata.categoryid = '';
                        this.vmodeldeliverydate = '';
                        this.attributes.nosofchair = '',
                            this.attributes.doublebedmattresscolor = '',
                            this.attributes.wardrobecolor = '',
                            this.attributes.dressingtablecolor = '',
                            this.attributes.sidetablecolor = '',
                            this.attributes.doublebedmattresscolorcode = '',
                            this.attributes.wardrobecolorcode = '',
                            this.attributes.dressingtablecolorcode = '',
                            this.attributes.sidetablecolorcode = '',
                            this.attributes.top = '',
                            this.attributes.sofadesign = '',
                            this.attributes.sofasize = '',
                            this.attributes.sofafabric = '',
                            this.attributes.sofabody = '',
                            this.attributes.sofacushion = '',
                            this.attributes.sofapolish = '',
                            this.attributes.centertablename = '',
                            this.attributes.tablesize = '',
                            this.attributes.tablepolish = '',
                            this.attributes.tabletop = '',
                            this.attributes.sizeofmarble = '',
                            this.attributes.sizeofglass = '',
                            this.attributes.belowofglass = '',
                            this.attributes.beddesign = '',
                            this.attributes.doublebedmattresssize = '',
                            this.attributes.doublebedmaterial = '',
                            this.attributes.doublebedcolour = '',
                            this.attributes.wardrobesize = '',
                            this.attributes.wardrobematerial = '',
                            this.attributes.wardrobecolour = '',
                            this.attributes.dressingtablesize = '',
                            this.attributes.dressingmaterial = '',
                            this.attributes.dressingcolour = '',
                            this.attributes.sidetablesize = '',
                            this.attributes.sidetablematerial = '',
                            this.attributes.sidetablecolour = '',
                            this.attributes.diningchairdesign = '',
                            this.attributes.diningtabledesign = '',
                            this.attributes.diningsizeoftable = '',
                            this.attributes.diningsizeofmarble = '',
                            this.attributes.diningpolish = '',
                            this.attributes.diningbelowglass = '',
                            this.attributes.diningfabric = '',
                            this.attributes.remark = '',
                            this.attributes.sidetableremark = '',
                            this.attributes.dressingremark = '',
                            this.attributes.wardroberemark = '',
                            this.attributes.doublebedremark = '',
                            this.submitted = false;
                        this.getcustomerorder();
                        this.flashMessage.success({
                            message: 'Order Added Successfully',
                        });
                    })
                // .catch((error) => {
                //     console.log(error.response);
                // });

            }
        },

        fuseSearch(options, search) {
            const fuse = new Fuse(options, {
                keys: ['name', 'number'],
                shouldSort: true,
            })
            return search.length ?
                fuse.search(search).map(({
                    item
                }) => item) :
                fuse.list
        },
    },

    watch: {
        'orderdata.categoryid': function (value) {
            if (value !== '') {
                this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/getadditionalattributes/` + value).then((res) => {

                    var sofadesign = new Array();
                    var sofasize = new Array();
                    var sofafabric = new Array();
                    var sofabody = new Array();
                    var sofacushion = new Array();
                    var sofapolish = new Array();
                    var centertablename = new Array();
                    var tablesize = new Array();
                    var tablepolish = new Array();
                    var tabletop = new Array();
                    var sizeofmarble = new Array();
                    var sizeofglass = new Array();
                    var belowofglass = new Array();
                    var beddesign = new Array();
                    var doublebedmattresssize = new Array();
                    var doublebedmaterial = new Array();
                    var doublebedcolour = new Array();
                    var wardrobesize = new Array();
                    var wardrobematerial = new Array();
                    var wardrobecolour = new Array();
                    var dressingtablesize = new Array();
                    var dressingmaterial = new Array();
                    var dressingcolour = new Array();
                    var sidetablesize = new Array();
                    var sidetablematerial = new Array();
                    var sidetablecolour = new Array();
                    var diningchairdesign = new Array();
                    var diningtabledesign = new Array();
                    var diningsizeoftable = new Array();
                    var diningsizeofmarble = new Array();
                    var diningpolish = new Array();
                    var diningbelowglass = new Array();
                    var diningfabric = new Array();

                    var a = 0,
                        b = 0,
                        c = 0,
                        d = 0,
                        e = 0,
                        f = 0,
                        g = 0,
                        h = 0,
                        i = 0,
                        j = 0,
                        k = 0,
                        l = 0,
                        m = 0,
                        n = 0,
                        o = 0,
                        p = 0,
                        q = 0,
                        r = 0,
                        s = 0,
                        t = 0,
                        u = 0,
                        v = 0,
                        w = 0,
                        x = 0,
                        y = 0,
                        z = 0,
                        aa = 0,
                        bb = 0,
                        cc = 0,
                        dd = 0,
                        ee = 0,
                        ff = 0,
                        gg = 0;

                    res.data.forEach((obj, idx) => {
                        if (obj.name === 'Sofa Design') {
                            sofadesign[a] = obj
                            a++;
                        }
                        if (obj.name === 'Size') {
                            sofasize[b] = obj
                            b++;
                        }
                        if (obj.name === 'Fabric') {
                            sofafabric[c] = obj
                            c++;
                        }
                        if (obj.name === 'Body') {
                            sofabody[d] = obj
                            d++;
                        }
                        if (obj.name === 'Cushion') {
                            sofacushion[e] = obj
                            e++;
                        }
                        if (obj.name === 'Polish') {
                            sofapolish[f] = obj
                            f++;
                        }
                        if (obj.name === 'Name') {
                            centertablename[g] = obj
                            g++;
                        }
                        if (obj.name === 'Size of Table') {
                            tablesize[h] = obj
                            h++;
                        }
                        if (obj.name === 'Polish') {
                            tablepolish[i] = obj
                            i++;
                        }
                        if (obj.name === 'Table Top') {
                            tabletop[j] = obj
                            j++;
                        }
                        if (obj.name === 'Size of Marble') {
                            sizeofmarble[k] = obj
                            k++;
                        }
                        if (obj.name === 'Size of Top') {
                            sizeofglass[l] = obj
                            l++;
                        }
                        if (obj.name === 'Below Glass') {
                            belowofglass[m] = obj
                            m++;
                        }
                        if (obj.name === 'Design') {
                            beddesign[n] = obj
                            n++;
                        }
                        if (obj.name === 'Bed Mattress Size') {
                            doublebedmattresssize[o] = obj
                            o++;
                        }
                        if (obj.name === 'Type of Material') {
                            doublebedmaterial[p] = obj
                            p++;
                        }
                        if (obj.name === 'Color/Polish') {
                            doublebedcolour[q] = obj
                            q++;
                        }

                        if (obj.name === 'Wardrobe Size') {
                            wardrobesize[r] = obj
                            r++;
                        }
                        if (obj.name === 'Wardrobe Material') {
                            wardrobematerial[s] = obj
                            s++;
                        }
                        if (obj.name === 'Wardrobe Color/Polish') {
                            wardrobecolour[t] = obj
                            t++;
                        }

                        if (obj.name === 'Dressing Table Size') {
                            dressingtablesize[u] = obj
                            u++;
                        }
                        if (obj.name === 'Dressing Table Material') {
                            dressingmaterial[v] = obj
                            v++;
                        }
                        if (obj.name === 'Dressing Table Color/Polish') {
                            dressingcolour[w] = obj
                            w++;
                        }

                        if (obj.name === 'Side Table Size') {
                            sidetablesize[x] = obj
                            x++;
                        }
                        if (obj.name === 'Side Table Material') {
                            sidetablematerial[y] = obj
                            y++;
                        }
                        if (obj.name === 'Side Table Color/Polish') {
                            sidetablecolour[z] = obj
                            z++;
                        }
                        if (obj.name === 'Chair Design') {
                            diningchairdesign[aa] = obj
                            aa++;
                        }
                        if (obj.name === 'Table Design') {
                            diningtabledesign[bb] = obj
                            bb++;
                        }
                        if (obj.name === 'Size of Table') {
                            diningsizeoftable[cc] = obj
                            cc++;
                        }
                        if (obj.name === 'Size of Marble') {
                            diningsizeofmarble[dd] = obj
                            dd++;
                        }
                        if (obj.name === 'Polish') {
                            diningpolish[ee] = obj
                            ee++;
                        }
                        if (obj.name === 'Below Glass') {
                            diningbelowglass[ff] = obj
                            ff++;
                        }
                        if (obj.name === 'Fabric') {
                            diningfabric[gg] = obj
                            gg++;
                        }

                    });

                    this.sofadesign = sofadesign;
                    this.sofasize = sofasize;
                    this.sofafabric = sofafabric;
                    this.sofabody = sofabody;
                    this.sofacushion = sofacushion;
                    this.sofapolish = sofapolish;
                    this.centertablename = centertablename;
                    this.tablesize = tablesize;
                    this.tablepolish = tablepolish;
                    this.tabletop = tabletop;
                    this.sizeofmarble = sizeofmarble;
                    this.sizeofglass = sizeofglass;
                    this.belowofglass = belowofglass;
                    this.beddesign = beddesign;
                    this.doublebedmattresssize = doublebedmattresssize;
                    this.doublebedmaterial = doublebedmaterial;
                    this.doublebedcolour = doublebedcolour;
                    this.wardrobesize = wardrobesize;
                    this.wardrobematerial = wardrobematerial;
                    this.wardrobecolour = wardrobecolour;
                    this.dressingtablesize = dressingtablesize;
                    this.dressingmaterial = dressingmaterial;
                    this.dressingcolour = dressingcolour;
                    this.sidetablesize = sidetablesize;
                    this.sidetablematerial = sidetablematerial;
                    this.sidetablecolour = sidetablecolour;
                    this.diningchairdesign = diningchairdesign;
                    this.diningtabledesign = diningtabledesign;
                    this.diningsizeoftable = diningsizeoftable;
                    this.diningsizeofmarble = diningsizeofmarble;
                    this.diningpolish = diningpolish;
                    this.diningbelowglass = diningbelowglass;
                    this.diningfabric = diningfabric;

                });
            }
        }
    },

    mounted() {
        this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/customerdetailfromorderid/` + this.$route.params.id).then((data) => {
            this.customerdata = data.data;
        });
        this.getcustomerorder();
        this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/getactivecategory`).then((category) => {
            this.category = category.data;
        });
    }

};
</script>

<style lang="scss">
.dropdown-input {
    margin-top: 5px;
    height: 45px;
}

.datashow {
    margin-bottom: 10px;
}

ul#vs1__listbox {
    cursor: pointer;
}

.createorder {
    display: flex;
    float: right;
}

// input[type="text"] {
//     width: 210px;
//     color: #212529;
//     height: 38px;
//     border-radius: 0.375rem;
//     font-size: 1rem;
//     border: 1px solid #ced4da;
//     line-height: 1.5;
// }
</style>
